export enum TagType {
  LANGUAGE = 'language',
  ZONE = 'zone',
  FORMAT = 'format',
  SUBJECT = 'subject',
  GENERAL = 'general',
  CHANNEL = 'channel',
}
